import { useState } from "react";
import { SUPPORTED_LANGUAGES } from "../../constants";
import { useBreakpoint, useLanguageContext } from "../../hooks";
import { Icon, IconGlyph } from "../../lib/Icon";
import { getBrowserLanguageCode } from "../../utils";

export interface LanguageDropdownProps {
  activeLanguage: string;
  onLanguageClick: (lng: string) => void;
}

const LanguageDropdownMenuItems = ({
  activeLanguage,
  onLanguageClick,
}: LanguageDropdownProps) => {
  return (
    <>
      {SUPPORTED_LANGUAGES.map((language) => {
        return (
          <div className="language-dropdown__menu-item" key={language.code}>
            <button
              className={
                language.code === activeLanguage
                  ? "language-dropdown__option-selected"
                  : "language-dropdown__option"
              }
              onClick={(_e) => onLanguageClick(language.code)}
            >
              {language.code === activeLanguage && (
                <Icon
                  glyph={IconGlyph.CHECK}
                  className="language-dropdown__option-icon"
                />
              )}
              <span
                className={
                  language.code === activeLanguage
                    ? "language-dropdown__option-text-selected"
                    : "language-dropdown__option-text"
                }
              >
                {language.title}
              </span>
            </button>
          </div>
        );
      })}
    </>
  );
};

export const LanguageDropdown = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { lng, toggleLngPref } = useLanguageContext();
  const { isDesktop } = useBreakpoint();

  const handleLanguageDropdown = (selected: string) => {
    if (lng !== selected) {
      toggleLngPref(selected);
    }
    setIsVisible(false);
  };
  let localStorageLanguage = getBrowserLanguageCode(lng);
  const selectedLanguage = SUPPORTED_LANGUAGES.find((x) => x.code === localStorageLanguage);
  const selectedLanguageLabel = isDesktop
    ? selectedLanguage?.title
    : selectedLanguage?.code;

  return (
    <div className="language-dropdown">
      <div
        className={
          isVisible
            ? "language-dropdown__toggle-open"
            : "language-dropdown__toggle"
        }
        onClick={() => setIsVisible((currentState) => !currentState)}
      >
        <WorldSVG />
        <span className="language-dropdown__toggle-text">
          {selectedLanguageLabel}
        </span>
        <Icon className="language-dropdown__toggle-icon" glyph={IconGlyph.DOWN_OPEN} />
      </div>
      {isVisible && (
        <div className="language-dropdown__menu">
          <LanguageDropdownMenuItems
            activeLanguage={lng}
            onLanguageClick={(lng: string) => handleLanguageDropdown(lng)}
          />
        </div>
      )}
    </div>
  );
};

const WorldSVG = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0559 8.41262H12.4219C12.5533 7.79896 12.6189 7.32786 12.6189 6.9993C12.6189 6.67074 12.5533 6.19963 12.4219 5.58598H10.0559C10.1218 6.04587 10.1547 6.51698 10.1547 6.9993C10.1547 7.48162 10.1218 7.95273 10.0559 8.41262ZM8.80731 12.2901C10.1435 11.8517 11.1621 11.0191 11.8632 9.79229H9.79299C9.57379 10.6686 9.24523 11.5012 8.80731 12.2901ZM8.64326 8.41262C8.70916 7.95273 8.74211 7.48162 8.74211 6.9993C8.74211 6.51698 8.70916 6.04587 8.64326 5.58598H5.35673C5.29084 6.04587 5.25789 6.51698 5.25789 6.9993C5.25789 7.48162 5.29084 7.95273 5.35673 8.41262H8.64326ZM7 12.586C7.61365 11.6877 8.06279 10.7567 8.34742 9.79299H5.65258C5.93721 10.7572 6.38635 11.6882 7 12.586ZM4.20701 4.20631C4.42621 3.32999 4.75477 2.49738 5.19269 1.70846C3.85648 2.14685 2.83786 2.97947 2.13681 4.20631H4.20701ZM2.13681 9.79229C2.83786 11.0191 3.85648 11.8517 5.19269 12.2901C4.7543 11.5012 4.42574 10.6686 4.20701 9.79229H2.13681ZM1.57807 8.41262H3.94412C3.87822 7.95273 3.84527 7.48162 3.84527 6.9993C3.84527 6.51698 3.87822 6.04587 3.94412 5.58598H1.57807C1.44674 6.19963 1.38107 6.67074 1.38107 6.9993C1.38107 7.32786 1.44674 7.79896 1.57807 8.41262ZM7 1.41262C6.38635 2.3109 5.93721 3.2419 5.65258 4.20561H8.34742C8.06279 3.24143 7.61365 2.31043 7 1.41262ZM11.8639 4.20631C11.1628 2.97947 10.1442 2.14685 8.80801 1.70846C9.2464 2.49738 9.57496 3.32999 9.79369 4.20631H11.8639ZM7 0C8.92789 0 10.5765 0.684694 11.9459 2.05408C13.3153 3.42347 14 5.07211 14 7C14 8.92789 13.3153 10.5765 11.9459 11.9459C10.5765 13.3153 8.92789 14 7 14C5.07211 14 3.42347 13.3153 2.05408 11.9459C0.684694 10.5765 0 8.92789 0 7C0 5.07211 0.684694 3.42347 2.05408 2.05408C3.42347 0.684694 5.07211 0 7 0Z"
        fill="#737373"
      />
    </svg>
  );
};
